import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { ReactComponent as InfoIcon } from '../../../assets/img/icons/info-circle.svg'
import { ReactComponent as CloseIcon } from '../../../assets/img/icons/close.svg'
import './styles.scss'
import { connect } from 'react-redux'
import { preferencesActions } from '../../../redux/actions/preferences'

function InfoBar (props) {
  const className = classNames('InfoBar', props.className)
  const dismissedAt = props.dismissedAt[props.infoId] ?? null

  const handleClose = () => {
    props.dismissInfoBar(props.infoId, props.userId)
    if (props.onClose) {
      props.onClose()
    }
  }

  const isDismissible = props.maxDismissalDurationInMinutes != null

  if (dismissedAt && isDismissible) {
    const dismissalDurationInMinutes = props.maxDismissalDurationInMinutes
    if (Date.now() - dismissedAt < dismissalDurationInMinutes * 60 * 1000) {
      return null
    }
  }

  return (
    <div className={className} role="status">
      <span className="InfoBar__icon">
        <InfoIcon/>
      </span>
      <div className="InfoBar__content">
        {props.children}
      </div>
      {
        isDismissible && <button
          type="button"
          aria-label="Dismiss"
          className="InfoBar__close"
          onClick={handleClose}
        >
          <CloseIcon/>
        </button>
      }
    </div>
  )
}

InfoBar.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  className: PropTypes.string,
  infoId: PropTypes.string.isRequired,
  maxDismissalDurationInMinutes: PropTypes.number,
}

const mapStateToProps = (state) => {
  if (!state.user) {
    return {
      userId: null,
      dismissedAt: {},
    }
  }
  return {
    userId: state.user.userId,
    dismissedAt: state.preferences?.infoBarDismissedAt?.[state.user.userId] ?? {},
  }
}

const mapDispatchToProps = {
  dismissInfoBar: preferencesActions.dismissInfoBar,
}

export default connect(mapStateToProps, mapDispatchToProps)(InfoBar)
